/**
 *
 * Asynchronously loads the component for UserProfile
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserProfilePopOver = lazyLoad(
  () => import('./index'),
  module => module.UserProfile
);
